import React, { useState } from "react";

import {
  IconButton,
  TableCell,
  TableRow,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Tooltip,
  TableHead,
  Table,
  TableBody,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { formattedDate } from "../../../../helpers/dateFormat";

import { useTranslation } from "react-i18next";
import DeleteSingleDisruption from "./DeleteSingleDisruption";

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#f3f8fe",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const TrainDisruptionItem = ({ disruption }) => {
  return (
    <StyledTableRow>
      <TableCell>
        <DeleteSingleDisruption disruption={disruption} />
      </TableCell>
      <TableCell sx={{ textTransform: "capitalize" }}>
        {disruption?.type?.toLowerCase()}
      </TableCell>
      <TableCell sx={{ textTransform: "uppercase" }}>
        {disruption?.line?.code}
      </TableCell>
      <TableCell sx={{ textTransform: "uppercase" }}>
        {disruption?.type === "station-closure"
          ? "-"
          : disruption?.fromStation?.abbreviation}
      </TableCell>
      <TableCell sx={{ textTransform: "uppercase" }}>
        {disruption?.type === "station-closure"
          ? "-"
          : disruption?.direction === "asc"
            ? "left"
            : disruption?.direction === "desc"
              ? "right"
              : disruption?.direction === "sector"
                ? "sector down"
                : "both"}
      </TableCell>
      <TableCell sx={{ textTransform: "uppercase" }}>
        {disruption?.type === "station-closure"
          ? "-"
          : disruption?.toStation?.abbreviation}
      </TableCell>
      <TableCell>
        <AffectedStationList data={disruption?.affectedStations} />
      </TableCell>
      <TableCell>
        {disruption?.isMessageHidden || disruption?.type === "station-closure"
          ? "-"
          : disruption?.type === "delay"
            ? disruption?.delayMinutes + " minutes"
            : formattedDate(disruption?.resumeAt)}
      </TableCell>
      <TableCell>{formattedDate(disruption?.createdAt)}</TableCell>
    </StyledTableRow>
  );
};

const AffectedStationList = ({ data }) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      {data?.length}{" "}
      {data?.length !== 0 && (
        <>
          <Tooltip title="View Affected Stations">
            <IconButton
              size="small"
              onClick={() => {
                setOpen(true);
              }}
            >
              <OpenInNewIcon fontSize="inherit" color="primary" />
            </IconButton>
          </Tooltip>

          <Dialog
            open={open}
            onClick={() => {
              setOpen(false);
            }}
            fullWidth
            maxWidth="xs"
          >
            <DialogContent>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t("affectedStationTable.code")}</TableCell>
                    <TableCell>{t("affectedStationTable.name")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((item) => (
                    <StyledTableRow key={item.code}>
                      <TableCell>{item.code}</TableCell>
                      <TableCell>
                        {item.name + " (" + item.abbreviation + ")"}
                      </TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </DialogContent>
            <DialogActions>
              <Button
                fullWidth
                onClick={() => setOpen(false)}
                variant="contained"
                color="primary"
              >
                {tCommon("closeBtn")}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default TrainDisruptionItem;
